module.exports = "https://cdn.realtymogul.com/static/media/icon_collapse.f275a61a.svg";